import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

// dataSeries 傳入格式：[{ date, name, value }, ...]
// 例如：{ date: "2025-07-01", name: "稀土金屬", value: 29217492 }
const buildChartData = (dataSeries) => {
  if (!dataSeries?.length) return { chartData: [], seriesNames: [] };

  // 固定順序：稀土金屬在左（先渲染），稀土磁鐵在右
  const seriesNames = ["稀土金屬", "稀土磁鐵"];

  // 以 date 為 key 聚合成 { date, 稀土金屬: value, 稀土磁鐵: value }
  const map = {};
  dataSeries.forEach(({ date, name, value }) => {
    const key = date.slice(0, 7); // "2025-07-01" → "2025-07"
    if (!map[key]) map[key] = { date: key };
    map[key][name] = value ?? 0;
  });

  // 按日期排序
  const chartData = Object.values(map).sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  return { chartData, seriesNames };
};

const COLORS = ["#1E9FD8", "#E8734A"];

const RareEarthChart = ({ dataSeries }) => {
  const { chartData, seriesNames } = buildChartData(dataSeries);

  if (!chartData.length) return <div>暫無數據</div>;

  return (
    <ResponsiveContainer width="100%" height={600}>
      <BarChart
        data={chartData}
        margin={{ top: 30, right: 80, left: 80, bottom: 30 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          angle={-45}
          textAnchor="end"
          tick={{ fontSize: 12 }}
          height={80}
          label={{
            value: "月份",
            position: "insideBottom",
            offset: -5,
          }}
        />
        <YAxis
          tickFormatter={(v) => `$${(v / 1000000).toFixed(0)}M`}
          label={{
            value: "月度金額 (百萬美元)",
            angle: -90,
            position: "insideLeft",
            offset: -60,
            style: { textAnchor: "middle" },
          }}
        />
        <Tooltip
          formatter={(value, name) => [
            `$${(Number(value) / 1000000).toFixed(2)}M`,
            name,
          ]}
          labelFormatter={(label) => `日期: ${label}`}
          contentStyle={{
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        />
        <Legend wrapperStyle={{ paddingTop: "20px" }} />

        {/* 並列雙柱：不傳 stackId */}
        {seriesNames.map((name, index) => (
          <Bar
            key={name}
            dataKey={name}
            name={name}
            fill={COLORS[index % COLORS.length]}
            maxBarSize={40}
            radius={[3, 3, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RareEarthChart;